module.exports = __webpack_public_path__ + "media/images/background/background-4-6330a63c2b2e16140f668680223e2f30.svg";